<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="actCatMain">
          <project-asset v-on:project-changed="onProjectChange" v-on:vessel-changed="onVesselChange"></project-asset>
          <v-card id="actCatCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t('nav.activityMaster') }}</v-card-title>
            <v-data-table
              id="actCatTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"
              
              :sort-by="['activityId']"
              :sort-desc="[false]"
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: right">{{ props.item.activityId }}</td>
                  <td style="text-align: left">{{ props.item.projectName }}</td>
                  <td style="text-align: left">{{ props.item.vesselName }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: center">{{ props.item.status ? 1 : 0 }}</td>
                  <td style="text-align: left">{{ props.item.activityCategoryName }}</td>
                  <td style="text-align: left">{{ props.item.activityTypeName }}</td>
                  <td style="text-align: center">{{ props.item.payed ? $t('common.yes') : $t('common.no') }}</td>
                  <td style="text-align: right">{{ props.item.unit }}</td>
                  <td style="text-align: right">{{ props.item.prodUnit }}</td>
                  <td style="text-align: left">{{ props.item.type }}</td>
                  <td style="text-align: left">{{ props.item.toolName }}</td>
                  <td style="text-align: left">{{ props.item.coding }}</td>
                  <td>
                    <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)">
                      <v-icon small color="primary">mdi-delete</v-icon> </v-btn
                    >&nbsp;
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted" @click="editItem(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="showDialog" max-width="65%">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field
                            class="form-control"
                            v-model="editedItem.activityId"
                            :rules="[() => !!editedItem.activityId || requiredMessage]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('nav.activityMasterId') }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-select
                            :rules="[() => !!editedItem.projectId || requiredMessage]"
                            required
                            :items="projects"
                            item-text="Name"
                            item-value="Id"
                            v-model="editedItem.projectId"
                            :readonly="editedIndex != -1"
                            @change="onDlgProjectChange"
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('common.projectName') }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select
                            :rules="[() => !!editedItem.vesselId || requiredMessage]"
                            required
                            class="form-control"
                            :items="projectVessels"
                            item-text="Name"
                            item-value="Id"
                            v-model="editedItem.vesselId"
                            :readonly="editedIndex != -1"
                            @change="onDlgVesselChange"
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('nav.vessels') }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field
                            class="form-control"
                            v-model="editedItem.description"
                            :rules="[() => !!editedItem.description || requiredMessage]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('column.description') }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select class="form-control" :items="statusOptions" item-text="text" item-value="value" v-model="editedItem.status">
                            <template v-slot:label>{{ $t('actMaster.status') }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select class="form-control" :items="payedOptions" item-text="text" item-value="value" v-model="editedItem.payed">
                            <template v-slot:label>{{ $t('actMaster.payed') }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select
                            class="form-control"
                            :items="activityCategories"
                            item-text="description"
                            item-value="id"
                            v-model="editedItem.activityCategoryId"
                          >
                            <template v-slot:label>{{ $t('nav.activityCategory') }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select class="form-control" :items="activityTypes" item-text="description" item-value="id" v-model="editedItem.activityTypeId">
                            <template v-slot:label>{{ $t('nav.activityType') }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field class="form-control" v-model="editedItem.unit">
                            <template v-slot:label>{{ $t('actMaster.unit') }}</template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field class="form-control" v-model="editedItem.prodUnit">
                            <template v-slot:label>{{ $t('actMaster.prodUnit') }}</template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field class="form-control" v-model="editedItem.type">
                            <template v-slot:label>{{ $t('actMaster.type') }}</template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select class="form-control" :items="tools" item-text="description" item-value="id" v-model="editedItem.toolId" clearable>
                            <template v-slot:label>{{ $t('common.tool') }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field class="form-control" v-model="editedItem.coding">
                            <template v-slot:label>{{ $t('actMaster.coding') }}</template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">
                    {{ $t('common.cancel') }}
                  </v-btn>
                  <v-btn color="primary" :disabled="!formIsValid" text type="submit" @click="save">{{ $t('common.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-btn id="btnAddactCat" color="primary" dark small left fab @click="createItem()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>

              <v-btn class="ml-5" color="primary" @click="dialogImport = !dialogImport">
                <span class="text-caption">{{ $t("common.importFile") }}</span>
                <v-icon class="ml-3">mdi-microsoft-excel</v-icon>
              </v-btn>
              <v-btn class="ml-5" color="success" :href="exportExcel()" :disabled="disabledExportBtn" @click="mShowInfoMessage('Excel export requested')">
                <span class="text-caption">{{ $t("common.exportFile") }}</span>
                <v-icon class="ml-3">mdi-download</v-icon>
              </v-btn>

            </v-card-actions>

            <v-dialog v-model="dialogImport" persistent width="500">
              <v-card>
                <v-card-title
                  ><span class="headline">{{ $t("common.importFile") }}</span></v-card-title
                >

                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-select :rules="[() => !!importDlg.projectId || requiredMessage]" required :items="projects" item-text="Name" item-value="Id" v-model="importDlg.projectId" :readonly="editedIndex != -1" @change="onDlgImportProjectChange"
                        ><template v-slot:label>
                          <v-icon color="red" x-small>mdi-asterisk</v-icon>
                          {{ $t("common.projectName") }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select :rules="[() => !!importDlg.vesselId || requiredMessage]" required class="form-control" :items="projectVesselsImport" item-text="Name" item-value="Id" v-model="importDlg.vesselId" :readonly="editedIndex != -1" @change="onDlgimportVesselChange">
                        <template v-slot:label>
                          <v-icon color="red" x-small>mdi-asterisk</v-icon>
                          {{ $t("common.asset") }}
                        </template>
                      </v-select></v-col
                    >
                    <v-col cols="12">
                      <v-file-input v-model="file" accept=".xlsx" prepend-icon="mdi-microsoft-excel" label="Choose file to import" class="ma-2" @change="onFilePicked"></v-file-input>
                      <span v-if="showError" style="color: red">{{ $t("common.fileformaterror") }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-checkbox class="ml-3" v-model="emptyFolder">
                        <template v-slot:label>
                          {{ $t("common.emptyFolder") }}
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="warning" text @click="dialogImport = !dialogImport">{{ $t("common.cancel") }}</v-btn>

                  <v-btn color="primary" text :disabled="canUpload" @click="actionUpload()">{{ $t("common.import") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ProjectAsset from '../common/ProjectAsset'
import Vue from "vue";

export default {
  components: {
      'project-asset': ProjectAsset
  },
  data() {
    return {
      showDialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('nav.activityMasterId'),
          align: 'right',
          sortable: true,
          value: 'activityId',
          width: '10%'
        },
        {
          text: this.$t('common.projectName'),
          align: 'left',
          value: 'projectId'
        },
        {
          text: this.$t('common.asset'),
          align: 'left',
          value: 'vesselId'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'description'
        },
        {
          text: this.$t('actMaster.status'),
          align: 'center',
          value: 'status',
          width: '5%'
        },
        {
          text: this.$t('nav.activityCategory'),
          align: 'left',
          value: 'activityCategoryId',
          width: '10%'
        },
        {
          text: this.$t('nav.activityType'),
          align: 'left',
          value: 'activityTypeId'
        },
        {
          text: this.$t('actMaster.payed'),
          align: 'center',
          value: 'payed',
          width: '5%'
        },
        {
          text: this.$t('actMaster.unit'),
          align: 'right',
          value: 'unit',
          width: '5%'
        },
        {
          text: this.$t('actMaster.prodUnit'),
          align: 'right',
          value: 'prodUnit',
          width: '5%'
        },
        {
          text: this.$t('actMaster.type'),
          align: 'left',
          value: 'type',
          width: '10%'
        },
        { text: this.$t('common.tool'), align: 'left', value: 'toolId' },
        { text: this.$t('actMaster.coding'), align: 'left', value: 'coding' },
        {
          text: this.$t('column.actions'),
          align: 'center',
          value: 'actActions',
          sortable: false,
          width: '10%'
        }
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null,
      dialogImport: false,
      showError: false,
      file: null,
      emptyFolder: false,
      selectedPvId: null,
      importDlg: {
        projectId: null,
        vesselId: null,
        selectedPvId: null,
      },
      excellink: "activity/export?pvId=",
      statusOptions: [
        { text: 1, value: true },
        { text: 0, value: false }
      ],
      payedOptions: [
        { text: this.$t('common.yes'), value: true },
        { text: this.$t('common.no'), value: false }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getProjectVesselMappings',
      'm_activity/getNextSeqCode',
      'm_activity/getActivities',

      'm_actCat/getActivityCategories',
      'm_actType/getActivityTypes',
      'm_tool/getTools',

      'm_project/getProjectNames',
      'm_project/getProjectVesselIds',

      'm_vessel/getVesselNames',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',
      'm_passet/getSelProjectVesselIds'
    ]),

    projectVesselsImport() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.selectedPrj) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },

    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.activityMaster')
        : this.$t('common.edit') + ' ' + this.$t('nav.activityMaster')
    },

    items() {
      return this['m_activity/getActivities']
    },

    tools() {
      return this['m_tool/getTools']
    },

    activityTypes() {
      return this['m_actType/getActivityTypes']
    },

    activityCategories() {
      return this['m_actCat/getActivityCategories']
    },

    projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },

    projectVessels() {
      let pvIds = this['m_passet/getSelProjectVesselIds']
      if (this.dlgSelProjectId) {
        pvIds = this['m_project/getProjectVesselIds']
      }

      return this['m_vessel/getVesselNames'].filter((v) => (pvIds || []).indexOf(v.Id) !== -1)
    },

    formIsValid() {
      return this.editedItem.activityId && this.editedItem.description
    },

    canUpload() {
      return !this.file && !this.showError && !this.selectedPrj && !this.selectedVessel;
    },

    selectedPrj() {
      return this.importDlg.projectId;
    },

    selectedVessel() {
      return this.importDlg.vesselId;
    },
    
    disabledExportBtn() {
      return this.selVesselId ? (this.selProjectId ? false : true) : true;
    },

  },
  watch: {
    showDialog(val) {
      val || this.close()
    },

    selectedPrj: async function() {
      if (this.selectedPrj && this.selectedVessel) {
        await this.fetchProjectVesselMappings();
        this.importDlg.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selectedPrj && pv.vesselId == this.selectedVessel);
      }
    },

    selectedVessel: async function() {
      if (this.selectedPrj && this.selectedVessel) {
        await this.fetchProjectVesselMappings();
        this.importDlg.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selectedPrj && pv.vesselId == this.selectedVessel);
      }
    },

    selVesselId: async function() {
      if (this.selProjectId && this.selVesselId) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selProjectId && pv.vesselId == this.selVesselId);
      } else this.selectedPvId = null;
    },

    selProjectId: async function() {
      if (this.selProjectId && this.selVesselId) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selProjectId && pv.vesselId == this.selVesselId);
      } else this.selectedPvId = null;
    },
  },

  created() {
    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']

    this.$log.debug('loading activities for', this.selProjectId, this.selVesselId)
    this.refreshActivities()
    this.refreshNextSeqCode()

    this['m_tool/fetchTools'](1)
    this['m_actCat/fetchActivityCategories'](1)
    this['m_actType/fetchActivityTypes']()
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  },
  methods: {
    ...mapMutations(['mHideLongLoader', 'mShowInfoMessage']),
    ...mapActions([
      'm_tool/fetchTools',
      'm_actType/fetchActivityTypes',
      'm_actCat/fetchActivityCategories',
      "m_activity/updateActivityList",
      'm_activity/createActivity',
      'm_activity/fetchActivities',
      'm_activity/fetchNextMaxCode',
      'm_activity/updateActivity',
      'm_activity/deleteActivity',
      'm_project/fetchProjectVesselNames',
      'fetchProjectVesselMappings'
    ]),

    refreshActivities() {
      this['m_activity/fetchActivities']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    onDlgImportProjectChange() {
      this["m_project/fetchProjectVesselNames"](this.selectedPrj);
    },

    onDlgimportVesselChange() {
      if (!this.selectedPrj || !this.selectedVessel) {
        return;
      }
    },

    onProjectChange(value) {
      this.selProjectId = value
      this.refreshActivities()
    },

    onVesselChange(value) {
      this.selVesselId = value
      this.refreshActivities()
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId
      this.$log.debug('dlg project change', this.dlgSelProjectId)
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)
      this.refreshNextSeqCode()
    },

    onDlgVesselChange() {
      this.$log.debug('dlg vessel changed', this.editedItem.vesselId)
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return
      }

      this.refreshNextSeqCode()
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId

      this['m_activity/fetchNextMaxCode']({
        pId: pId,
        vId: vId
      }).then((nextCode) => {
        this.editedItem.activityId = nextCode
        this.$nextTick(() => this.$forceUpdate())
      })
    },

    resetEntity(item) {
      this.dlgSelProjectId = null
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)

      this.defaultItem.projectId = this['m_passet/getSelProjectId']
      this.defaultItem.vesselId = this['m_passet/getSelVesselId']

      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.onDlgProjectChange()
      this.showDialog = true
    },

    createItem() {
      this.resetEntity()

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange()
      }

      this.refreshNextSeqCode()
      this.editedItem.activityId = this['m_activity/getNextSeqCode']
      this.showDialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)

      var msg = this.editedItem.isDeleted ? 'warming.unlock' : 'warming.lock'
      this.$confirm(this.$t(msg) + this.$t('nav.activityMaster') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then((res) => res && this['m_activity/deleteActivity'](this.editedItem).then(this.refreshActivities))
    },

    close() {
      this.$refs.form.resetValidation()
      this.showDialog = false
    },

    save() {
      if (~this.editedIndex) {
        this['m_activity/updateActivity'](this.editedItem).then(this.refreshActivities)
      }

      if (!~this.editedIndex) {
        this['m_activity/createActivity'](this.editedItem).then(this.refreshActivities)
      }
      this.close()
    },

    exportExcel() {
      let pvId = "";
      try {
        pvId = this.selectedPvId ? this.selectedPvId[0].id : "";
      } catch (err) {
        pvId = "";
      }
      //let pvId = this.selectedPvId ? this.selectedPvId[0].id : "";
      if (this.excellink) return Vue.$hrefWithParams(this.excellink + pvId);
      return undefined;
    },

    onFilePicked() {
      this.$log.debug(this.file);
      let sp = this.file.name.split(".");
      if (this.file) {
        if (sp[1] != "xlsx") {
          this.showError = true;
        } else this.showError = false;
      }
    },

    async actionUpload() {
      let payload = {
        pvId: this.importDlg.selectedPvId[0].id,
        file: this.file,
        resetOldValues: this.emptyFolder,
      };

      await this["m_activity/updateActivityList"](payload)
        .then(this.refreshActivities)
        .then((this.dialogImport = false));
    },  
  }
}
</script>

<style>
#actCatTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#actCatTable header {
  font-weight: bold;
}
#actCatCard {
  width: auto;
}
</style>